import makeStyles from '@mui/styles/makeStyles';
import MatchCriteria from "components/Matching/MatchCriteria";
import {filter, get, isEmpty, map} from 'lodash';
import React from "react";
import {useTranslation} from "react-i18next";
import {font, match, type} from "common/tokens";

const useStyles = makeStyles({
  label: {
    ...type.eyebrow,
    color: match.ACCENT,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 10,
  },
  empty: {
    fontFamily: font.SANS,
    fontSize: 11.5,
    color: match.CHIP_MUTED_FG,
    marginTop: 8,
  },
  clashBlock: {
    marginTop: 12,
  },
});

const MatchingCriteriaGroup = ({criterias, clashingCriterias, onTint}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  const iconFor = criteria => get(criterias, `${criteria}.icon`);
  const nameFor = criteria => get(criterias, `${criteria}.name`);
  const mandatory = filter(criterias, criteria => criteria.mandatory);
  const hasClashes = !isEmpty(clashingCriterias);

  return (
    <div>
      <div className={classes.label}>{t('mentorshipGroupNeeds')}</div>

      {isEmpty(mandatory) ? <div className={classes.empty}>{t('noGroupNeeds')}</div> : (
        <div className={classes.chips}>
          {map(mandatory, criteria => (
            <MatchCriteria
              key={criteria.name}
              criteria={criteria.name}
              icon={criteria.icon}
              onTint={onTint}
              status={hasClashes ? MatchCriteria.criteriaStatus.INACTIVE : MatchCriteria.criteriaStatus.ACTIVE}/>
          ))}
        </div>
      )}

      {hasClashes && (
        <div className={classes.clashBlock}>
          <div className={classes.label}>{t('clashingCriteria')}</div>
          <div className={classes.chips}>
            {map(clashingCriterias, criteria => (
              <MatchCriteria
                key={criteria}
                criteria={nameFor(criteria)}
                icon={iconFor(criteria)}
                status={MatchCriteria.criteriaStatus.CLASHING}/>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MatchingCriteriaGroup;
